import React from "react";
import Link from "next/link";
import { signOut } from "next-auth/react";
import PersonIcon from "@mui/icons-material/Person";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import LogoutIcon from "@mui/icons-material/Logout";
import ShareIcon from "@mui/icons-material/Share";
import CustomDropdown from "../../components/ui/CustomDropdown";

const ProfileDropdown = ({ session, t }) => {
  const initials = session?.user?.name
    ? session.user.name
        .split(" ")
        .map((n) => n[0])
        .join("")
    : session?.user?.email
    ? session.user.email.slice(0, 2).toUpperCase()
    : "U";

  const dropdownTrigger = (
    <span
      className="avatar avatar-sm rounded-circle d-flex align-items-center justify-content-center cursor-pointer"
      style={{
        width: "40px",
        height: "40px",
        backgroundColor: "var(--bs-bota-strong-cyan-lime-green)",
        fontSize: "1rem",
        fontWeight: "bold",
        color: "var(--bs-bota-light-grayish-orange)",
        userSelect: "none",
      }}
    >
      {session?.user ? initials : <AccountCircleIcon />}
    </span>
  );

  const dropdownMenu = (
    <>
      {session?.user && (
        <>
          <li className="tw-px-3 tw-py-2 tw-mb-1 tw-border-b tw-border-gray-200 tw-list-none">
            <p className="tw-font-semibold tw-text-gray-900 tw-m-0">
              {session.user.name || t("common:top-nav.my-profile")}
            </p>
            <p className="tw-text-sm tw-text-gray-500 tw-m-0 tw-truncate">
              {session.user.email}
            </p>
          </li>
          <hr className="dropdown-divider tw-my-1" />
        </>
      )}

      <li className="tw-list-none">
        <Link
          href="/profile"
          className="tw-flex tw-items-center tw-px-4 tw-py-2 tw-rounded-md hover:tw-bg-gray-100 tw-text-gray-700 tw-text-sm tw-w-full"
          passHref
        >
          <PersonIcon className="tw-w-5 tw-h-5 tw-text-gray-600" />
          <span className="ms-3">{t("common:top-nav.my-profile")}</span>
        </Link>
      </li>

      <li className="tw-list-none">
        <Link
          href="/billing"
          className="tw-flex tw-items-center tw-px-4 tw-py-2 tw-rounded-md hover:tw-bg-gray-100 tw-text-gray-700 tw-text-sm tw-w-full"
          passHref
        >
          <ReceiptLongIcon className="tw-w-5 tw-h-5 tw-text-gray-600" />
          <span className="ms-3">{t("common:menu.billing")}</span>
        </Link>
      </li>

      <hr className="dropdown-divider tw-my-1" />

      <li className="tw-list-none tw-px-2 tw-py-1">
        <Link href="/affiliates" className="tw-block" passHref>
          <div className="tw-p-2 tw-rounded-md tw-text-dark tw-border tw-border-yellow-500 tw-bg-yellow-100 hover:tw-bg-yellow-200 tw-transition-colors">
            <div className="d-flex align-items-center">
              <ShareIcon className="tw-w-5 tw-h-5 tw-text-yellow-600" />
              <span className="ms-2 tw-font-medium tw-text-sm tw-text-gray-800">
                {t("common:top-nav:referral")}
              </span>
            </div>
          </div>
        </Link>
      </li>

      {session && (
        <>
          <hr className="dropdown-divider tw-my-1" />

          <li className="tw-list-none">
            <a
              className="tw-flex tw-items-center tw-px-4 tw-py-2 tw-rounded-md hover:tw-bg-red-100 tw-text-sm tw-w-full"
              href="#"
              onClick={() => signOut({ redirect: false })}
            >
              <LogoutIcon className="tw-w-5 tw-h-5 tw-text-red-500" />
              <span className="ms-3 tw-font-medium tw-text-red-600">
                {t("common:top-nav.logout")}
              </span>
            </a>
          </li>
        </>
      )}
    </>
  );

  return (
    <CustomDropdown
      trigger={dropdownTrigger}
      menu={dropdownMenu}
      alignRight={true}
    />
  );
};

export default ProfileDropdown;
